import { Observable } from "rxjs";
import { AbstractScreenHandler, CRUDGenericService, TypeValidatorService } from 'attcei-bo-fw';
import { BasicContainerDTO } from '../classes/dto/BasicContainerDTO';
import { ContainerDTO } from '../classes/dto/ContainerDTO';
import { ScreenHandler } from 'attcei-bo-fw/lib/screen/interfaces/ScreenHandler';
import { Injectable } from '@angular/core';
import { PaginationState } from 'attcei-bo-fw/lib/classes/PaginationState';
import { Sort } from '@angular/material/sort';
import { PaginatedDTO } from 'attcei-bo-fw/lib/classes/dto/PaginatedDTO';

@Injectable({
    providedIn:'root'
})

export class ContainerScreenHandler extends AbstractScreenHandler<BasicContainerDTO, ContainerDTO> implements ScreenHandler<BasicContainerDTO, ContainerDTO>{
    constructor(private service: CRUDGenericService, typeValidator: TypeValidatorService){
        super(typeValidator);
    }
    
    loadListData(filter: any, paginationState: PaginationState, sort: Sort): Observable<PaginatedDTO<ContainerDTO>> {
        var url:string = this.getURL() + this.buildInvocationWithPaginationAndFilter(paginationState, filter, sort);
        return this.service.getDataList(url, true);
    }

    post(item: BasicContainerDTO):Observable<ContainerDTO> {
        console.log("Recebi no post -> ", item);
        var dto: BasicContainerDTO = super.parse(item);
        var res: Observable<ContainerDTO> = this.service.postData(this.getURL(),dto,true);
        console.log("result -> ", res);
        return res;
    }

    update(item: ContainerDTO):Observable<ContainerDTO> {
        console.log("Recebi no update -> ", item);
        var dto: ContainerDTO = super.parse(item);
        var res: Observable<ContainerDTO> = this.service.putData(this.getURL(), dto.id, dto, true);
        console.log("parsed -> ", res);
        return res;
    }

    delete(item: any):Observable<ContainerDTO> {
        return this.service.delete(this.getURL(), item.id, true);
    }

    getItem(id: number):Observable<ContainerDTO> {
        return this.service.getDataItem(this.getURL(), true, id);
    }

    getURL(): string {
        return "container"
    }

    getId(item: ContainerDTO): number {
        return item.id;
    }
    
    protected getUpdateTypeName(): string {
        return "ContainerDTO";
   
    }    
    
    protected getCreateTypeName(): string {
        return "BasicContainerDTO";
    }
}